import { Seat, type TSeat } from './types';

export interface ISessionStanding {
  readonly seat: TSeat;
  readonly rank: number;
  readonly startingBalance: number;
  readonly delta: number;
  readonly endingBalance: number;
}

const ALL_SEATS = [Seat.Self, Seat.Right, Seat.Opposite, Seat.Left] as const;

export const buildSessionStandings = (
  startingBalances: readonly [number, number, number, number],
  endingBalances: readonly [number, number, number, number]
): readonly ISessionStanding[] => {
  const sorted = ALL_SEATS.map((seat) => ({
    seat,
    startingBalance: startingBalances[seat],
    endingBalance: endingBalances[seat],
  })).sort((left, right) => right.endingBalance - left.endingBalance || left.seat - right.seat);

  return sorted.map((entry, index) => ({
    ...entry,
    rank:
      index > 0 && sorted[index - 1]!.endingBalance === entry.endingBalance
        ? sorted
            .slice(0, index)
            .findIndex((previous) => previous.endingBalance === entry.endingBalance) + 1
        : index + 1,
    delta: entry.endingBalance - entry.startingBalance,
  }));
};
